import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-job-post-listing',
  templateUrl: './job-post-listing.component.html',
  styleUrls: ['./job-post-listing.component.css']
})
export class JobPostListingComponent implements OnInit {
  formatLabel(value: number) {
    if (value >= 1000) {
      return Math.round(value / 1000) + 'k';
    }

    return value;
  }
  public isCollapsed1 = false;
  public isCollapsed2 = false;
  public isCollapsed3 = false;
  public isCollapsed4 = false;
  public isCollapsed5 = false;
  public isCollapsed6 = false;

  constructor() { }

  ngOnInit(): void {
  }

}
